// removed by extract-text-webpack-plugin
module.exports = {"product":"product","wrap-img":"wrap-img","product-image":"product-image","name":"name","name-link":"name-link","price":"price","price-sale":"price-sale","price-old":"price-old","price-throught":"price-throught","sale-percent":"sale-percent","description":"description","company-name":"company-name","send-request":"send-request","add-to-cart":"add-to-cart"};


//////////////////
// WEBPACK FOOTER
// ./components/users/_User.scss
// module id = ./components/users/_User.scss
// module chunks = 1